import React, { Component } from 'react'
import Rank from '../components/Rank/Rank';
import Transaction from '../components/Transaction/Transaction';
import Searchbox from '../components/Search/Search';
import Graph from '../components/Graph/Graph'
import {auth,firestore} from '../firebase/firebase.utils'
import {Link} from 'react-router-dom'
export default class Home extends Component {
    state= {
        search: "",
        History: "",
        users : []
    }
    showSearch = () => {
        this.setState({search:'show'})
      }
      showHistory = () => {
        this.setState({History:'show'})
      }
      componentDidMount() {
        const that = this;
        let c = []
        firestore.collection("users").get()
        .then(function(querySnapshot) {
            querySnapshot.forEach(function(doc) {
                c.push(doc.data())
        });
        that.setState({users:c})
        })
        .catch(function(error) {
            console.log("Error getting documents: ", error);
        });
      }
    render() {
        if(auth.email){
          return <div>
            <h3>You need to be signed in to access this page</h3>
            <Link to="/signup">SignIn</Link>
          </div>
        }
        else{
          const {user,loadUser} = this.props
        return (
            <div>
                <Rank
                name={user.name}
                showSearch={this.showSearch}
                showHistory={this.showHistory}
                entries={user.entries}
                currentUser={user.email}
              />
              {this.state.search==='show'
              ?<Searchbox currentId={user.id} users={this.state.users} currentUser={user} loadUser={loadUser} entries={user.entries} />
              :(user.isBlocked===true
                 ? <div className="f1 white">Your Account has been Blocked</div>
                 :<div></div>
                )
              }
               {this.state.History==='show'
                ?<Transaction currentId={user.email}/>
                 :<div></div>
                
              }
              <Graph route="user"/>
              
            </div>
        )
    }
  }
}
